/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner
     */
    selected_option: string;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "selected_option" in value;

    return isInstance;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'selected_option': json['selected_option'],
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON(value?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'selected_option': value.selected_option,
    };
}

